import {types, flow, getParent} from 'mobx-state-tree';
import {values, when} from 'mobx';
import {sortBy} from 'lodash';

import MarketItem from './market';
import {marketGroupActions, marketsFetches} from './matches-instances-actions';
import {foldCase} from '../../../../../common/utils';

const MarketGroupInstance = types
    .model('MarketGroupInstance', {
        id: types.identifierNumber /* i */,
        order: types.number /* o */,
        markets: types.map(MarketItem) /* m */,
        name: types.maybeNull(types.string),
        shortName: types.maybeNull(types.string),
        parentId: types.maybeNull(types.number),
    })
    .extend((s) => ({
        actions: {...marketsFetches(s), ...marketGroupActions(s)},
    }))
    .actions((s) => ({
        removeItems: flow(function* fetch() {
            yield when(
                () => !values(s.markets).find((market) => market.isWaitingUpdate)
            );
            clearTimeout(window.__marketsUpdater);
            Promise.all([
                values(s.markets).map((market) => {
                    market.removeItems();
                }),
            ]).then(() => {
                getParent(s, 2).deleteItem({id: s.id});
            });
        }),

        deleteItem({id}) {
            s.markets.delete(id);
        },
    }))
    .views((s) => ({

        // ##========================================================================================
        // ##                                                                                      ##
        // ##                                   View markets list                                  ##
        // ##                                                                                      ##
        // ##========================================================================================

        marketsList(marketsCount = 0) {
            let order = marketsCount ? (marketsCount - s.marketsListLength()) : 0;
            return sortBy(values(s.markets), ['order', 'name'], 'asc').reduce((acc, market) => [...acc, {market, viewOrder: order++}], []);
        },

        marketsListSearchedBy(search) {
            const needle = foldCase(search);
            if (!needle) {
                return [];
            }
            let searchedMarketsViewOrder = 0;
            return s.marketsList().reduce((acc, item) => {
                const market = item.market;
                const labels = [market.name, market.shortName, market.shortedName, market.baseName];
                const matches = labels.some((label) => foldCase(label).includes(needle));
                if (matches) {
                    item.viewOrder = searchedMarketsViewOrder;
                    searchedMarketsViewOrder++;
                    return [...acc, item];
                }
                return acc;
            }, []);
        },

        marketsListLength() {
            return s.markets.size;
        },
    }));

export default MarketGroupInstance;
